import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

const Header = (props) => (
	<header id="header" style={props.timeout ? { display: 'none' } : {}}>
		<div className="content">
			<div className="inner">
				<h1>Dalton Carr</h1>
				<p>Front End Developer</p>
			</div>
		</div>
		<nav>
			<ul>
				<li>
					<Link to="/work">Work</Link>
				</li>
				<li>
					<a
						href="javascript:;"
						onClick={() => {
							props.onOpenArticle('about');
						}}
					>
						About
					</a>
				</li>
				<li>
					<a href="mailto:daltcarr@gmail.com">Contact</a>
				</li>
			</ul>
		</nav>
		<ul className="icons">
			<li>
				<a href="https://github.com/daltlc" className="icon fa-github">
					<span className="label">GitHub</span>
				</a>
			</li>
		</ul>
	</header>
);

Header.propTypes = {
	onOpenArticle: PropTypes.func,
	timeout: PropTypes.bool
};

export default Header;
